<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-07 14:59:36
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-26 11:26:52
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\funDesc\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<el-dialog :visible.sync="visible" :title="title" :before-close="beforeClose" width="400px">
			<div class="renovation align-center">
				<el-image :src="qrLink" lazy />
				<p class="yx-color-pure-1 font-h4-medium mt-8">{{ content }}</p>
			</div>
			<div slot="footer">
				<el-button type="primary" @click="beforeClose">知道了</el-button>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="visibleCheck" title="提示" :before-close="beforeCloseCheck" width="400px">
			<p>
				<i class="el-icon-info yx-color-warning fz-16"></i>
				<span class="yx-color-pure-1 ml-6 font-h4-regular">暂时无法预览选品中心</span>
			</p>
			<p>请管理员在子账号管理中创建“达人商务”子账号后，才可预览</p>
			<div slot="footer">
				<el-button type="primary" @click="beforeCloseCheck">知道了</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { tplQrUrl } from '@/api/selectionDecoration';
import { wechatQrUrl } from '@/utils/common.js';
export default {
	computed: {
		title({ previewType }) {
			const obj = {
				preview_goods: '预览',
				preview_center: '选品中心',
			};
			return obj[previewType];
		},
		content({ previewType }) {
			const obj = {
				preview_goods: '微信扫码预览',
				preview_center: '微信扫码查看选品中心',
			};
			return obj[previewType];
		},
	},
	data() {
		return {
			visible: false,
			visibleCheck: false,
			qrLink: '',
			previewType: 'preview_goods',
		};
	},
	methods: {
		async show(params) {
			this.previewType = params.preview;
			const { code, qrLink, shareCode } = await tplQrUrl(params);
			if (code) return (this.visibleCheck = true);
			this.qrLink = params.preview === 'preview_goods' ? qrLink : wechatQrUrl(shareCode);
			this.visible = true;
		},
		beforeClose() {
			this.previewType = 'preview_goods';
			this.visible = false;
		},
		beforeCloseCheck() {
			this.previewType = 'preview_goods';
			this.visibleCheck = false;
		},
	},
};
</script>
<style lang="less" scoped>
.renovation {
	.el-image {
		width: 140px;
	}
}
</style>
